import { FilterSearchInput } from '@/components/filters/filter-search-input';
import { activeFilterTypeState } from '@/components/filters/filter.state';
import { useHandleFilters } from '@/components/filters/use-handle-filters';
import { useProjectsFiltersSearchLocationSearch } from '@/features/projects/filters/use-projects-filters-location-search';
import type { IProjectFilters } from '@/features/projects/project.state';
import {
  appliedProjectsFiltersState,
  selectedProjectsFiltersState,
} from '@/features/projects/project.state';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

export const SearchProjectsInput = () => {
  const { t } = useTranslation('projects');

  const [activeFilterType, setActiveFilterType] = useAtom(
    activeFilterTypeState,
  );

  const appliedFilters = useAtomValue(appliedProjectsFiltersState);

  const { updateLocationSearch, resetLocationSearch } =
    useProjectsFiltersSearchLocationSearch();

  const { handleSearchInputChange, clearSearchInput, switchToSearchFilter } =
    useHandleFilters<IProjectFilters>({
      appliedFiltersAtom: appliedProjectsFiltersState,
      selectedFiltersAtom: selectedProjectsFiltersState,
      updateLocationSearch,
      resetLocationSearch,
    });
  return (
    <FilterSearchInput
      onChange={handleSearchInputChange}
      placeholder={t`projects.searchByName`}
      onRemove={clearSearchInput}
      isInputActivated={
        activeFilterType === 'search' || !!appliedFilters.search
      }
      onInputActivate={switchToSearchFilter}
      onInputDeactivate={() => setActiveFilterType(null)}
      defaultValue={appliedFilters.search ?? ''}
      displayIconOnly
    />
  );
};
